/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';

import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';
import { CategoryTable } from './table/CategoryTable';
import Create from './modals/Create';
import Filter from './Filter';

export default function Category() {
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [chipData, setChipData] = useState([]);

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [name, setName] = useState('');

  const handleCleanCreate = () => {
    setName('');
    setOpenCreate(false);
  };

  const handleCreate = async () => {
    if (!name || name.trim().length === 0) {
      notifyError('Informe o nome da categoria');
      return;
    }

    setLoadingCreate(true);
    try {
      const { data: response } = await api.category.create({ name });
      notifySuccess(response.message);
      handleCleanCreate();
      searchData();
    } catch (error) {
      if (error.problems?.length > 0) {
        error.problems.forEach(err => notifyError(err.msg));
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingCreate(false);
    }
  };

  const searchData = async currentChips => {
    setLoading(true);
    const filtersToUse = currentChips || chipData;
    try {
      const response = await api.category.getAll(filtersToUse, itens, page + 1);
      setTotal(response.data.total);
      setData(response.data.docs);
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  return (
    <>
      <Loading open={loading} msg="Carregando categorias..." />
      <Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'start' }}
        >
          <h3>Categorias</h3>
        </Grid>

        <Filter
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
          setPage={setPage}
          setOpenDialog={setOpenCreate}
        />

        <CategoryTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          searchData={searchData}
        />
      </Grid>

      <Create
        openCreate={openCreate}
        setOpenCreate={setOpenCreate}
        loadingCreate={loadingCreate}
        handleCreate={handleCreate}
        name={name}
        setName={setName}
        handleClean={handleCleanCreate}
      />
    </>
  );
}